const solutions = [
  {
    id: 'enclosures',
    title: 'Custom Plastic Enclosures for Embedded & Industrial Systems',
    desc: 'We design and manufacture precision-molded plastic enclosures for rugged, field-deployable electronic systems. Our enclosures are engineered for durability, ergonomic usability, and seamless integration with electronics.',
    useCases: [
      'Industrial handheld terminals (2" / 3" display with keypad)',
      'Portable printers',
      'IoT edge devices and sensor nodes',
      'Agricultural smart starter systems',
      'Smart water meter housings',
    ],
    industries: [
      'Industrial Automation',
      'IoT & Smart Infrastructure',
      'AgriTech',
      'Utilities (Water / Energy)',
    ],
    applications: [
      'Field data collection devices',
      'Smart metering systems',
      'Portable embedded devices',
      'Edge computing nodes',
    ],
    tags: ['Enclosures', 'Embedded', 'Industrial'],
    imageCandidates: ['/images/DSC_0192-cutout.jpg', '/images/DSC_0185-cutout.jpg'],
  },
  {
    id: 'tooling',
    title: 'Injection Molds & Dies for High-Volume Production',
    desc: 'We develop high-precision molds and dies optimized for repeatability, durability, and production efficiency. Our tooling ensures consistent quality across large manufacturing runs.',
    useCases: [
      'Enclosures for handheld devices',
      'IoT housings',
      'Industrial plastic components',
    ],
    industries: [
      'Electronics Manufacturing',
      'Consumer Devices',
      'Industrial Equipment',
    ],
    applications: [
      'Injection molding production lines',
      'Mass manufacturing of plastic parts',
      'High-precision component fabrication',
    ],
    tags: ['Tooling', 'Molds', 'Production'],
    imageCandidates: ['/images/Dies.jpg'],
  },
  {
    id: 'thermal',
    title: 'Heat Sink Profiles for Power & Industrial Systems',
    desc: 'We engineer aluminium heat sink profiles designed for efficient thermal dissipation in high-power electronic systems.',
    useCases: [
      'Rooftop solar inverters',
      'Agricultural pump controllers',
      'Power electronics systems',
    ],
    industries: [
      'Renewable Energy',
      'Power Electronics',
      'Industrial Automation',
    ],
    applications: [
      'Thermal management of control systems',
      'Heat dissipation in embedded electronics',
      'High-load electrical systems',
    ],
    tags: ['Thermal', 'Heat Sinks', 'Power'],
    imageCandidates: ['/images/aluminium.png'],
  },
  {
    id: 'elastomer',
    title: 'Custom Rubber Components for Sealing & Protection',
    desc: 'We manufacture precision rubber components designed for sealing, vibration damping, and environmental protection.',
    useCases: [
      'Gaskets',
      'Connector caps',
      'Cable grommets',
    ],
    industries: [
      'Electronics',
      'Automotive',
      'Industrial Equipment',
    ],
    applications: [
      'Environmental sealing',
      'Shock absorption',
      'Cable protection systems',
    ],
    tags: ['Elastomer', 'Sealing', 'Protection'],
    imageCandidates: ['/images/rubber-products.jpg'],
  },
  {
    id: 'printing',
    title: 'Printer Ribbon Systems for Portable Impact Printers',
    desc: 'We supply high-quality printer ribbon assemblies designed for reliability in portable and industrial printing systems.',
    useCases: [
      '2" portable impact printers',
      'Field billing systems',
      'Mobile ticketing devices',
    ],
    industries: [
      'Retail',
      'Logistics',
      'Field Services',
    ],
    applications: [
      'Receipt printing',
      'Mobile transaction systems',
      'On-site documentation',
    ],
    tags: ['Printing', 'Field Devices', 'Consumables'],
    imageCandidates: ['/images/ribbon.jpg', '/images/DSC_0194-cutout.jpg'],
  },
  {
    id: 'connectivity',
    title: 'Antennas, Adapters & Cable Assemblies',
    desc: 'We design and manufacture connectivity components ensuring reliable power, data, and RF communication across devices.',
    useCases: [
      'Monopole antennas',
      'Power adapters',
      'USB / data cables',
      'Optical cables for meter reading',
    ],
    industries: [
      'IoT',
      'Telecom',
      'Industrial Electronics',
    ],
    applications: [
      'Wireless communication systems',
      'Power delivery systems',
      'Data transfer interfaces',
      'Smart metering networks',
    ],
    tags: ['Connectivity', 'RF', 'Cables'],
    imageCandidates: ['/images/DSC_0206-cutout.jpg', '/images/DSC_0212-cutout.jpg'],
  },
  {
    id: 'integrated',
    title: 'Electronics + Mechanical – Built Together',
    desc: 'Through our collaboration with Analogics Tech India Ltd., we combine electronics design, firmware, and hardware expertise with C2P\'s mechanical engineering and manufacturing capabilities.',
    useCases: [
      'Have a Product Idea? Let\'s Build It Together',
    ],
    industries: [
      'Product Innovation',
      'Embedded Systems',
      'Industrial Electronics',
    ],
    applications: [
      'Integrated product realization',
      'Full-stack product development',
    ],
    tags: ['Integrated', 'Electronics + Mechanical', 'Product Realization'],
    imageCandidates: ['/images/Handheld-case.jpg', '/images/AR7A3721.JPG', '/images/tech-network.png'],
  },
];

export default solutions;
